import { generateNomenApi, generateNomenOptions } from '@feature/nomenclature';

const bookMembershipApi = generateNomenApi(`/book/book-membership`);

export const bookMembershipOptions = generateNomenOptions('book-membership', bookMembershipApi);
